import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-175d24e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "indexlayout-main-conent" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title1" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "账户信息")
], -1))
const _hoisted_3 = {
  class: "account-item-it1",
  style: {"font-size":"13px"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = { key: 4 }
const _hoisted_9 = {
  key: 0,
  class: "account-title account-title2"
}
const _hoisted_10 = { class: "account-item-it1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "account-amount" }
const _hoisted_13 = { style: {"display":"flex","justify-content":"center","margin-top":"40px"} }
const _hoisted_14 = {
  key: 1,
  class: "account-item-it1"
}
const _hoisted_15 = { class: "account-title account-title2" }
const _hoisted_16 = { class: "account-amount" }
const _hoisted_17 = { style: {"font-size":"20px"} }
const _hoisted_18 = { class: "account-title account-title2" }
const _hoisted_19 = { class: "account-amount" }
const _hoisted_20 = { style: {"font-size":"20px"} }
const _hoisted_21 = { style: {"text-align":"right","padding-right":"20px"} }
const _hoisted_22 = {
  key: 0,
  class: "account-title account-title4"
}
const _hoisted_23 = { class: "account-item-it1" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "account-amount" }
const _hoisted_26 = { style: {"display":"flex","justify-content":"center","margin-top":"40px"} }
const _hoisted_27 = {
  key: 1,
  class: "account-item-it1"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "可用额度")
], -1))
const _hoisted_29 = { class: "account-amount" }
const _hoisted_30 = { style: {"font-size":"20px"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title4" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "可用现金")
], -1))
const _hoisted_32 = { class: "account-amount" }
const _hoisted_33 = { style: {"font-size":"20px"} }
const _hoisted_34 = { style: {"text-align":"right","padding-right":"20px"} }
const _hoisted_35 = {
  key: 0,
  class: "account-title account-title3"
}
const _hoisted_36 = { class: "account-item-it1" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "account-amount" }
const _hoisted_39 = { style: {"display":"flex","justify-content":"center","margin-top":"40px"} }
const _hoisted_40 = {
  key: 1,
  class: "account-item-it1"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "冻结额度")
], -1))
const _hoisted_42 = { class: "account-amount" }
const _hoisted_43 = { style: {"font-size":"20px"} }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-title account-title3" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "冻结现金")
], -1))
const _hoisted_45 = { class: "account-amount" }
const _hoisted_46 = { style: {"font-size":"20px"} }
const _hoisted_47 = { style: {"text-align":"right","padding-right":"20px"} }
const _hoisted_48 = { class: "title-border-bottom" }
const _hoisted_49 = { class: "h2-blue-underline" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["href"]
const _hoisted_52 = ["href"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", null, "下载", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, {
          gutter: 24,
          class: "account-item"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.accountinfo.accountType == 1 ? 'account-item-child1' : 'account-item-child2')
            }, [
              _hoisted_2,
              _createVNode(_component_a_row, { style: {"padding-left":"15px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t('page.account.accountquery.primaryAccountNumber')) + "：" + _toDisplayString(_ctx.email), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.t('page.account.accountquery.code')) + "：" + _toDisplayString(_ctx.accountinfo.userCode), 1),
                        _createElementVNode("span", null, _toDisplayString(_ctx.t('page.account.accountquery.date')) + "：" + _toDisplayString(_ctx.accountinfo.createdAt), 1),
                        (_ctx.accountinfo.accountType != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "账户状态：" + _toDisplayString(_ctx.accountinfo.status == 1? '正常':'冻结'), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_5, "账户状态：未激活")),
                        (_ctx.accountinfo.accountType != 1 && _ctx.accountinfo.accountType != '' && _ctx.accountinfo.accountType != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.t('page.account.accountquery.type')) + "： " + _toDisplayString(_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == 2 ? (_ctx.accountinfo.accountType == 1 ? _ctx.t('page.account.accountquery.prepaid') : _ctx.t('page.account.accountquery.period')) : ''), 1))
                          : _createCommentVNode("", true),
                        (_ctx.accountinfo.accountType != 1 && _ctx.accountinfo.accountType != '' && _ctx.accountinfo.accountType != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " 账单周期：" + _toDisplayString(_ctx.changeTxt(_ctx.accountinfo.cycle, "cycle")), 1))
                          : _createCommentVNode("", true),
                        (_ctx.accountinfo.accountType != 1 && _ctx.accountinfo.accountType != '' && _ctx.accountinfo.accountType != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, " 结算周期：" + _toDisplayString(_ctx.accountinfo.paymentTerm) + "天 ", 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null? 'account-item-child1': 'account-item-child2')
            }, [
              (_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.t("page.account.accountquery.account")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, " ￥" + _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.cashTotal)) || "0.00"), 1),
                      _createElementVNode("span", _hoisted_13, [
                        _createElementVNode("a", {
                          style: {"color":"#357ac8","text-decoration":"underline"},
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleGoto('recharge')))
                        }, _toDisplayString(_ctx.t("page.account.accountquery.viewRechargeDetails")), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.t("page.account.accountquery.credit")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_16, [
                        _createTextVNode(" ￥"),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.creditTotal)) || "0.00"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.t("page.account.accountquery.cash")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_19, [
                        _createTextVNode(" ￥"),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.cashTotal)) || "0.00"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("a", {
                          style: {"color":"#357ac8","text-decoration":"underline"},
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleGoto('recharge')))
                        }, _toDisplayString(_ctx.t("page.account.accountquery.viewRechargeDetails")), 1)
                      ])
                    ]))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null? 'account-item-child1': 'account-item-child2')
            }, [
              (_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.t("page.account.accountquery.balance")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_23, [
                (_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("span", _hoisted_25, " ￥" + _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.cashAvailable)) || "0.00"), 1),
                      _createElementVNode("span", _hoisted_26, [
                        _createElementVNode("a", {
                          style: {"color":"#357ac8","text-decoration":"underline"},
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleGoto('cost-cost')))
                        }, _toDisplayString(_ctx.t("page.account.accountquery.details")), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("span", _hoisted_29, [
                        _createTextVNode(" ￥"),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.creditAvailable)) || "0.00"), 1)
                      ]),
                      _hoisted_31,
                      _createElementVNode("span", _hoisted_32, [
                        _createTextVNode(" ￥"),
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.cashAvailable)) || "0.00"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("a", {
                          style: {"color":"#357ac8","text-decoration":"underline"},
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleGoto('cost-cost')))
                        }, _toDisplayString(_ctx.t("page.account.accountquery.details")), 1)
                      ])
                    ]))
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null ? 'account-item-child1' : 'account-item-child2')
            }, [
              (_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null
                  ? _ctx.t("page.account.accountquery.frozen")
                  : _ctx.t("page.account.accountquery.used")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_36, [
                (_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("span", _hoisted_38, " ￥" + _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.cashFrozen))), 1),
                      _createElementVNode("span", _hoisted_39, [
                        _createElementVNode("a", {
                          style: {"color":"#357ac8","text-decoration":"underline"},
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleGoto('cost-fizn')))
                        }, _toDisplayString(_ctx.t("page.account.accountquery.viewFrozenDetails")), 1)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("span", _hoisted_42, [
                        _createTextVNode(" ￥"),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.creditFrozen)) || 0.00), 1)
                      ]),
                      _hoisted_44,
                      _createElementVNode("span", _hoisted_45, [
                        _createTextVNode(" ￥"),
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.twoNumber1(Number(_ctx.accountinfo.cashFrozen)) || "0.00"), 1)
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("a", {
                          style: {"color":"#357ac8","text-decoration":"underline"},
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleGoto('cost-fizn')))
                        }, _toDisplayString(_ctx.t("page.account.accountquery.viewFrozenDetails")), 1)
                      ])
                    ]))
              ])
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_card, { style: {"margin-top":"10px"} }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("h2", _hoisted_49, _toDisplayString(_ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null ?
              _ctx.t("page.account.accountquery.deductionDetails"):
              _ctx.t("page.account.accountquery.inquiry")), 1)
        ]),
        _createVNode(_component_a_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "inline" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, _mergeProps({
                  label: 
              _ctx.accountinfo.accountType == 1 || _ctx.accountinfo.accountType == null
                ? _ctx.t('page.account.accountquery.expense')
                : _ctx.t('page.account.accountquery.datez')
            
                }, _ctx.validateInfos.time), {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      "value-format": "YYYY-MM-DD",
                      value: _ctx.modelRef.time,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modelRef.time) = $event)),
                      getPopupContainer: (triggerNode) => triggerNode.parentNode
                    }, null, 8, ["value", "getPopupContainer"])
                  ]),
                  _: 1
                }, 16, ["label"]),
                (_ctx.accountinfo.accountType == 2)
                  ? (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({
                      key: 0,
                      label: "账单编号"
                    }, _ctx.validateInfos.billCode), {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.modelRef.billCode,
                          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.modelRef.billCode) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 16))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.handleSearch
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("page.account.accountquery.search")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_row, { style: {"margin-top":"20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_table, {
              ref: "queryTable",
              style: {"width":"100%","min-height":"300px"},
              "row-key": "id",
              columns: _ctx.columns,
              dataSource: _ctx.accountinfo.accountType==1 || _ctx.accountinfo.accountType == null?_ctx.advtablelist:_ctx.acptablelist,
              loading: _ctx.loading,
              pagination: _ctx.pagination,
              scroll: {x:'calc(100%-100vw)'},
              size: "small",
              onChange: _ctx.handleTableChange
            }, _createSlots({ _: 2 }, [
              (_ctx.isT)
                ? {
                    name: "bodyCell",
                    fn: _withCtx(({column,record}) => [
                      (column.dataIndex === 'length')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(record.length +'*'+ record.width + '*' + record.height), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'billCycle')
                        ? (_openBlock(), _createBlock(_component_a_tooltip, {
                            key: 1,
                            placement: "left"
                          }, {
                            title: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(record.billStartTime) + " - " + _toDisplayString(record.billEndTime), 1)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(" " + _toDisplayString(record.billStartTime) + " - " + _toDisplayString(record.billEndTime), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'discount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(record.discount <= 0 ? '--' : record.discount), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'expenseType')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(record.expenseType, "expenseType")), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'cashFrozen')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.cashFrozen)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'money')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                            _createTextVNode(_toDisplayString(record.expenseProject == 1 || record.expenseProject == 2 || record.expenseProject == 12 || record.expenseProject == 13 ? _ctx.twoNumber1(record.money) || "0.00" : '-' + _ctx.twoNumber1(record.money) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'discountAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            _createTextVNode(_toDisplayString(record.expenseProject == 1 || record.expenseProject == 2 || record.expenseProject == 12 || record.expenseProject == 13 ? _ctx.twoNumber1(record.discountAmount) || "0.00" : '-' +  _ctx.twoNumber1(record.discountAmount) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'cashTotal')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.cashTotal)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'cashAvailable')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.cashAvailable)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'totalAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.totalAmount)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'cashCreditAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 10 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.cashCreditAmount)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'paidAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.paidAmount)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'payableAmount')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                            _createTextVNode(_toDisplayString(_ctx.twoNumber1(Number(record.payableAmount)) || "0.00"), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'expenseProject')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 13 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(record.expenseProject, "expenseProject")), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'reallength')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 14 }, [
                            _createTextVNode(_toDisplayString(record.actualLength+'*'+record.actualWidth+'*'+record.actualHeight), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'currency')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 15 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(record.currency, "currency")), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'billStatus')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 16 }, [
                            (record.billStatus === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(_ctx.changeTxt(record.billStatus, "billStatus")), 1))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleGoto('rechargepop')))
                                }, _toDisplayString(_ctx.changeTxt(record.billStatus, "billStatus")), 1))
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'hasBattery')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 17 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(record.hasBattery,'hasBattery')), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'paymentTerm')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 18 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(record.paymentTerm, 'paymentTerm')), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'productType')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 19 }, [
                            _createTextVNode(_toDisplayString(_ctx.changeTxt(record.productType, "productType")), 1)
                          ], 64))
                        : _createCommentVNode("", true),
                      (column.dataIndex === 'billDetails')
                        ? (_openBlock(), _createBlock(_component_a_popover, {
                            key: 20,
                            placement: "bottomLeft"
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("a", {
                                href: `${_ctx.apiHost}/seller/v1/accountBill/accountBillDownload?billCode=${record.billCode}`
                              }, "Excel", 8, _hoisted_51),
                              _createVNode(_component_a_divider, { type: "vertical" }),
                              _createElementVNode("a", {
                                href: `${_ctx.apiHost}/seller/v1/accountBill/accountBillDownloadPdf?billCode=${record.billCode}`
                              }, "PDF", 8, _hoisted_52)
                            ]),
                            default: _withCtx(() => [
                              _hoisted_53
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true)
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032, ["columns", "dataSource", "loading", "pagination", "scroll", "onChange"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}